// Artifactory
import {evaluateExperimentAndLog} from '@homeaway/abacus-client-utils';

// Relative Imports
import triggerEdap from '../api/edap';
import edapActions from '../actions/edapActions';
import getPricingInfoFromState from '../middleware/utils/getPricingInfoFromState';

const EVENT_CATEGORY = 'pdp page';
const BOOKING_BUTTON_CLICK = 'booking button click';
const LISTING_BOOKNOW_CLICK = 'listing.booknow.click';

let loggedPageview = false;
const queuedEvents = [];

/* istanbul ignore next */
function triggerEdapEvent(store, action = {payload: {eventName: '', eventData: '', options: {}}}) {
    const {payload} = action;

    // queue up all non-pageview events to be logged *after* the pageview event has been fired
    // (NOTE: we're doing this to ensure that the `pageview` event is logged before all other application events, which is a requirement
    // if we want to segment on PDP pageviews in ART readouts while looking at app metrics like `quote.attempt`)
    if (!loggedPageview && payload.eventName !== 'pageview') {
        queuedEvents.push(payload);
        return;
    }

    // this is either the pageview event or the pageview event has already been logged, so go ahead and log the event
    triggerEdap.call(window, payload.eventName, payload.eventData, payload.options);

    // check if we just logged the pageview event and flush all queued events if necessary
    if (payload.eventName === 'pageview') {
        loggedPageview = true;

        // 'ha_pdp_bizmetrics' is an AA test used solely to view edap metrics in datadog
        // We want to log it after pageview event.
        evaluateExperimentAndLog('ha_pdp_bizmetrics');

        queuedEvents.forEach((queuedEvent) => {
            triggerEdap.call(
                window,
                queuedEvent.eventName,
                queuedEvent.eventData,
                queuedEvent.options
            );
        });
    }
}

function getFullBookingUrl(listingObj) {
    // extract and format the checkout URL
    const bookingUrl = listingObj.checkoutUrl || null;
    return bookingUrl ? `${window.location.protocol}//${window.location.host}${bookingUrl}` : null;
}

// Trigger an event that looks like
// 'listing.booknow.click', {
//     href: fullBookingUrl,
//     ...
// }
function triggerEdapListingBooknowClick(store, action = {payload: {}}) {
    const state = store.getState();

    // get trip data
    const tripData = state.tripDetailsReducer;
    const eventArrival = tripData.arriveDateText;
    const eventDeparture = tripData.departDateText;
    const eventNumAdults = tripData.adults.toString();
    const eventNumChildren = tripData.children.toString();
    const eventHasPets = tripData.hasPets.toString();
    const eventActionLocation = action.payload.actionLocation;

    // get pricing + checkout data
    const pricingInfoObjJs = getPricingInfoFromState(state);
    const fullBookingUrl = getFullBookingUrl(pricingInfoObjJs);
    const eventTripTotal = pricingInfoObjJs.tripTotal;

    // populate edap event with trip details
    store.dispatch(
        edapActions.triggerEdapEvent(
            LISTING_BOOKNOW_CLICK,
            {
                href: fullBookingUrl,
                eventstartdate: eventArrival,
                eventenddate: eventDeparture,
                eventnumadults: eventNumAdults,
                eventnumchildren: eventNumChildren,
                eventpets: eventHasPets,
                triptotal: eventTripTotal,
                actionlocation: eventActionLocation,
                eventcategory: EVENT_CATEGORY,
                eventaction: BOOKING_BUTTON_CLICK
            },
            {
                delayProcessing: true
            }
        )
    );
}

function logTestExposure(store, action = {payload: {}}) {
    const {testName} = action.payload;
    evaluateExperimentAndLog(testName);
}

export default triggerEdapEvent;
export {
    logTestExposure,
    triggerEdapEvent,
    triggerEdapListingBooknowClick,
    getFullBookingUrl,
    EVENT_CATEGORY,
    BOOKING_BUTTON_CLICK,
    LISTING_BOOKNOW_CLICK
};
